import React from 'react';
import { Star } from '@strapi/icons';

const SkillsPluginIcon = () => <Star />;

export { SkillsPluginIcon };
